exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".login[data-v-5d964c89]{width:350px;max-width:100%}", "", {"version":3,"sources":["/home/runner/work/manager/manager/src/pages/Login.vue"],"names":[],"mappings":"AACA,wBACE,YAAa,AACb,cAAgB,CACjB","file":"Login.vue","sourcesContent":["\n.login[data-v-5d964c89] {\n  width: 350px;\n  max-width: 100%;\n}"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5d964c89","scoped":true,"hasInlineConfig":false}!./node_modules/stylus-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/Login.vue
// module id = 960
// module chunks = 22